// Remove Rebuy Console Log

document.addEventListener("rebuy.beforeLoaded", function () {
  /* Disable Rebuy console attribution */ window.Rebuy.disable_attribution = true;
});

// Size Chart Modal POPUP

document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.getElementById("pdp-size-chart-toggle");
  var modal = document.getElementById("size-chart-modal");
  var backdrop = document.getElementById("modal-backdrop");

  if (toggle) {
    toggle.addEventListener("click", function () {
      var isModalOpen = modal.style.display === "block";
      modal.style.display = isModalOpen ? "none" : "block";
      backdrop.style.display = isModalOpen ? "none" : "block";
    });
  }

  backdrop.addEventListener("click", function () {
    modal.style.display = "none";
    backdrop.style.display = "none";
  });
});

// Customer Support Dropdown in Header
document
  .querySelector(".support-dropbtn")
  .addEventListener("click", function () {
    var dropdownContent = document.querySelector(".support-dropdown-content");
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
    } else {
      dropdownContent.style.display = "block";
    }
  });

// Close the dropdown if the user clicks outside of it
window.onclick = function (event) {
  if (!event.target.matches(".support-dropbtn")) {
    var dropdowns = document.getElementsByClassName("support-dropdown-content");
    for (var i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.style.display === "block") {
        openDropdown.style.display = "none";
      }
    }
  }
};

$(document).ready(function () {
  displaySecondImageOnHoverOnCollectionPage();
  showMore();
  updateVariantNameOnCollectionPageOnSwatchClickHover();

  //replaceJsonOptionsOnPDP();
  clearanceDisclaimer();
  selectSwatchOnClick();
  selectSwatchOnClickPDP();
  //T4SThemeSP._initProducts;
  FixCatalogsAddedToDwawerCart();
  deleteCatalogFromMiniCart();
  //HideSwatchOnMarkdownOnRegularParent();
});

function selectSwatchOnClick() {
  var swatchItemElementSelected = $(".full-price, .markdown");
  swatchItemElementSelected.on("click", function () {
    swatchItemElementSelected.removeClass("is--selected");
  });
}

function selectSwatchOnClickPDP() {
  if (ShopifyAnalytics.meta.page.pageType == "product") {
    var swatchItemElement =
      "#MainContent .is-t4s-style__color .t4s-swatch__item";
    let reload_event = performance.getEntriesByType("navigation")[0].type;
    if (reload_event == "reload") {
      let swatchAutoSelected = $(
        ".is-t4s-style__color .t4s-swatch__item.is--selected"
      );

      setTimeout(function () {
        console.log(swatchAutoSelected);
        swatchAutoSelected.trigger("click");
      }, 500);
    }

    $("body").on("click", swatchItemElement, function () {
      let product_url = $(this).data("product-url");

      let variant_id = $(this).data("option-value-id");
      if (!variant_id) {
        console.log("Variant iD missing");
      }

      renderGallerySectionOnPDP(product_url);
      renderFabricSectionOnPDP(product_url);
      renderAplusSectionOnPDP(product_url);
      renderProductRelatedSectionOnPDP(product_url);
      getProductToActivateBackInStock(this, product_url);
      getSizeOnCollectionSwatchHover(this, product_url);
    });
  }
}

function renderGallerySectionOnPDP(current_product_url) {
  let section_id_selector = "shopify-section-template--img__refresh";
  let section_id = section_id_selector.replace(/^shopify-section-/g, "");

  $(`#${section_id_selector} .t4s-row.t4s-g-0`).addClass(
    "custom-pdp-img-gallery fade-out"
  );

  let section_url_to_fetch = `${window.location.origin}${current_product_url}?section_id=${section_id}`;

  fetchAndAttachSection(section_url_to_fetch, section_id_selector).then(
    (data) => {
      document.querySelector(`#${section_id_selector}`).innerHTML = data;

      T4SThemeSP.initCarousel();
      T4SThemeSP.Isotopet4s;
      T4SThemeSP.Isotopet4s.init;
      T4SThemeSP.Isotopet4s.initEach();
      T4SThemeSP.Carousel._initCarouselNav;
      T4SThemeSP.RenderRefresh();
      history.replaceState(null, "", current_product_url);
    }
  );
}

function renderProductRelatedSectionOnPDP(current_product_url) {
  let related_id_selector = "shopify-section-template--related__refresh";
  let related_section_id = related_id_selector.replace(
    /^shopify-section-/g,
    ""
  );
  let section_url_related_to_fetch = `${window.location.origin}${current_product_url}?section_id=${related_section_id}`;
  fetchAndAttachSection(section_url_related_to_fetch, related_id_selector).then(
    (data) => {
      document.querySelector(`#${related_id_selector}`).innerHTML = data;
      //T4SThemeSP.initCarousel();
      T4SThemeSP.reinitProductGridItem();
      T4SThemeSP.initCarousel();
      T4SThemeSP.Isotopet4s;
      T4SThemeSP.Isotopet4s.init;
      T4SThemeSP.Isotopet4s.initEach();
      T4SThemeSP.Carousel._initCarouselNav;
      T4SThemeSP.RenderRefresh();
    }
  );
}

function renderFabricSectionOnPDP(current_product_url) {
  let fabric_id_selector = "shopify-section-custom-fabric-pdp";
  let fabric_section_id = fabric_id_selector.replace(/^shopify-section-/g, "");
  let section_url_fabric_to_fetch = `${window.location.origin}${current_product_url}?section_id=${fabric_section_id}`;

  fetchAndAttachSection(section_url_fabric_to_fetch, fabric_id_selector).then(
    (data) => {
      document.querySelector(`#${fabric_id_selector}`).innerHTML = data;
    }
  );
}

function renderAplusSectionOnPDP(current_product_url) {
  let aplus_id_selector = "shopify-section-template--aplus__refresh";
  let aplus_section_id = aplus_id_selector.replace(/^shopify-section-/g, "");
  let section_url_aplus_to_fetch = `${window.location.origin}${current_product_url}?section_id=${aplus_section_id}`;

  fetchAndAttachSection(section_url_aplus_to_fetch, aplus_id_selector).then(
    (data) => {
      console.log("data renderAplusSectionOnPDP", data);
      if (data) {
        document.querySelector(`#${aplus_id_selector}`).innerHTML = data;
      }
    }
  );
}

function renderProductImageOnQuickShopModal() {
  const swatchSelector =
    "#t4s-product-quick-view .is-t4s-style__color .t4s-swatch__item";

  $("body")
    .off("click", swatchSelector)
    .on("click", swatchSelector, function () {
      const swatchAutoSelected = $(this);
      const product_url = $(this).data("product-url");

      // Llama a las funciones necesarias
      handleSwatchClickOnQuickShop(swatchAutoSelected);
      clearanceDisclaimerForQuickView(swatchAutoSelected);
      getProductToActivateBackInStock(this, product_url);
      //HideSwatchOnMarkdownOnRegularParent();
    });

  //selectSwatchOnClick();
  T4SThemeSP.reinitProductGridItem();
  T4SThemeSP.Product;
  T4SThemeSP.initCarousel();
  T4SThemeSP.Isotopet4s;
  T4SThemeSP.Isotopet4s.init;
  T4SThemeSP.Isotopet4s.initEach();
  T4SThemeSP.Carousel._initCarouselNav;
  T4SThemeSP.RenderRefresh();

  const initialSwatchClicked = collection_swatch_selected_on_hover
    ? `${swatchSelector}.${collection_swatch_selected_on_hover}`
    : `${swatchSelector}.is--selected`;

  $(initialSwatchClicked).trigger("click");
  collection_swatch_selected_on_hover = null;
}

async function getProductToActivateBackInStock(swatch_clicked, product_url) {
  let handle = product_url.split("?")[0];

  try {
    const response = await fetch(`${handle}.js`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const current_product_back_in_stock = await response.json();

    const productFormBtnCount = $(".t4s-product-form__buttons").length;
    const productContainerSelector =
      productFormBtnCount > 0
        ? ".BIS_trigger.t4s-product-form__submit"
        : ".BIS_trigger";

    $(productContainerSelector).attr(
      "data-product-data",
      JSON.stringify(current_product_back_in_stock)
    );
  } catch (error) {
    console.error("Error fetching the product:", error);
  }
}

function handleSwatchClickOnQuickShop(swatchSelected) {
  const source_section_id_selector = "shopify-section-template--img__refresh";

  const origin_section_id_selector =
    "shopify-section-template--quickshop__galery_refresh";

  $(`#${origin_section_id_selector} .t4s-row.t4s-g-0`).addClass(
    "custom-pdp-img-gallery fade-out"
  );

  let section_id = source_section_id_selector.replace(/^shopify-section-/g, "");
  let product_url = $(swatchSelected).data("product-url");
  let variant_id = $(swatchSelected).data("option-value-id");

  if (!product_url) {
    console.log("Product URL ID missing");
    return;
  }
  let section_url_to_fetch = `${window.location.origin}${product_url}?section_id=${source_section_id_selector}`;

  fetchAndAttachSection(section_url_to_fetch, source_section_id_selector)
    .then((data) => {
      document.querySelector(`#${origin_section_id_selector}`).innerHTML = data;
    })
    .catch((error) => {
      console.error("Error fetching section:", error);
    });
}

async function fetchAndAttachSection(url, section_id) {
  try {
    let response = await fetch(url);
    if (!response.ok) {
      console.log("error on response");
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    let responseText = await response.text();
    let htmlToAttach = new DOMParser()
      .parseFromString(responseText, "text/html")
      .querySelector(`#${section_id}`).innerHTML;

    // Add htmlToAttach to the current DOM Element
    return htmlToAttach;
    console.log("good insert element");
  } catch (error) {
    console.error("Error fetching and attaching section:", error);
  }
}

function overrideSwatchUrlMissing() {
  const swatchOptions = $(".is-t4s-style__color .t4s-swatch__item");

  swatchOptions.each(function () {
    let product_url = $(this).data("product-url");
    let product_id = $(this).data("option-value-id");
    let product_title = $(this).attr("title");

    if (!product_id || !product_url) {
      var option_selected = getOptionFromSelectElementHtml(product_title);
      $(this).data("option-value-id", option_selected.attr("value"));
      $(this).data("product-url", option_selected.data("variant-url"));
    }
  });
}

function getOptionFromSelectElementHtml(product_title) {
  const selectOptionElement = $('select.t4s-product__select[name="id"]');
  let first_option_available = null;

  first_option_available = selectOptionElement
    .find("option")
    .filter(function (index) {
      const current_option = $(this);
      const scv_title = current_option.data("variant-title");

      if (index === 0) {
        first_option_available = current_option;
      }
      return product_title === scv_title;
    })
    .first();
  return first_option_available;
}

let collection_swatch_selected_on_hover = null;
function displaySecondImageOnHoverOnCollectionPage() {
  var swatchSelector = ".t4s-pr-color__item[data-tooltip='top']";
  var eventToExecute = window.innerWidth <= 768 ? "click" : "mouseenter";
  $(document).on(eventToExecute, swatchSelector, function () {
    var index = $(this).index();

    // collection_swatch_selected_on_hover global variable to be use inside the method renderProductImageOnQuickShopModal
    //to select on quick view the right color image when the draw menu is open
    collection_swatch_selected_on_hover = $(this)
      .find('span[class*="bg_color"]')
      .first()
      .attr("class")
      ?.split(" ")
      .find((className) => className.startsWith("bg_color"));

    var productContainer = $(this).closest(".t4s-product-wrapper");

    var data_second_img = $(productContainer).attr("data-second-img");
    var imageUrlArray = data_second_img.split(",");

    var data_product_url_attr = $(productContainer).attr("data-product-url");
    var data_product_url_list = data_product_url_attr.split(",");

    var data_scv_price_attr = $(productContainer).attr("data-scv-price");
    var data_scv_price_list = data_scv_price_attr.split(", ");

    var data_compare_at_price_attr = $(productContainer).attr(
      "data-compare-at-price"
    );
    var data_compare_at_price_list = data_compare_at_price_attr.split(", ");

    productContainer
      .find(".t4s-product-hover-img")
      .attr("src", imageUrlArray[index]);

    productContainer
      .find("[data-pr-href]")
      .attr("href", data_product_url_list[index]);

    getSizeOnCollectionSwatchHover(this, data_product_url_list[index]);

    // productContainer
    //   .find(".t4s-product-btns a")
    //   .attr("href", data_product_url_list[index]);

    var current_price = data_scv_price_list[index];
    current_price = current_price.substring(1, current_price.length - 4);
    current_price = parseFloat(current_price);

    var compare_at_price = data_compare_at_price_list[index];
    compare_at_price = compare_at_price.substring(
      1,
      compare_at_price.length - 4
    );
    compare_at_price = parseFloat(compare_at_price);

    var element_price_selector = productContainer.find(".t4s-product-price");

    if (current_price != compare_at_price) {
      var html = `<del>
        ${data_compare_at_price_list[index]}
        </del>
        <ins class="custom-prod-on-sale">
        ${data_scv_price_list[index]}
        </ins>`;

      element_price_selector.html(html);
    } else {
      element_price_selector.text(data_compare_at_price_list[index]);
    }
  });
}

async function getSizeOnCollectionSwatchHover(swatch_clicked, product_url) {
  let handle = product_url.split("?")[0];
  let size_to_replace = "";
  try {
    const response = await fetch(`${handle}.js`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const current_product_sizes = await response.json();

    current_product_sizes.variants.map((variant) => {
      const isSoldOutUrl = variant.available ? product_url : "#";

      const isSoldOut_BackInStock = variant.available
        ? "t4s-pr-item-btn t4s-pr-addtocart"
        : "BIS_trigger t4s-pr-item-btn t4s-pr-addtocart t4s-product-sizes--sold-out";

      const data_product_data = !variant.available
        ? `data-product-data="${JSON.stringify(current_product_sizes).replace(
            /"/g,
            "&quot;"
          )}"`
        : "";

      const data_action_atc = variant.available
        ? "data-action-atc rel='nofallow'"
        : "";

      const span_size = variant.available
        ? `<span class="t4s-text-pr">${variant.option2}</span>`
        : variant.option2;

      size_to_replace += `
      <a 
        href = "${isSoldOutUrl}" 
        class='${isSoldOut_BackInStock}'  
        ${data_product_data}
        data-variant-id="${variant.id}" ${data_action_atc}>
        ${span_size}
      </a>`;
    });

    var productContainer = $(swatch_clicked).closest(".t4s-product-wrapper");
    productContainer
      .find(".custom-product-sizes .t4s-truncate")
      .html(size_to_replace);
  } catch (error) {
    console.error("Error fetching the product:", error);
  }
}

// Show More functionality for PDP description
function showMore() {
  var $pdpDesContainer = $("#custom_description_container");
  var $toggleDescBtn = $("#toggle-view-description-btn");
  $toggleDescBtn.click(function () {
    $pdpDesContainer.toggleClass("expander");
    $(this).text(
      $pdpDesContainer.hasClass("expander") ? "View Less -" : "View More +"
    );
  });
}

// Custom JS to change and display currently selected variant name under the product image on the collection page on Hover and Click
function updateVariantNameOnCollectionPageOnSwatchClickHover() {
  var swatchSelector = ".t4s-pr-color__item[data-tooltip='top']";
  var eventToExecute = window.innerWidth <= 768 ? "click" : "mouseenter";

  $(document).on(eventToExecute, swatchSelector, function () {
    var newColorSelection = $(this).find(".t4s-pr-color__name").text();
    var productContainer = $(this).closest(".t4s-product");
    productContainer.find(".current-variant-selected").text(newColorSelection);
  });
}

// Custom JS to be ordered in the same way that the admin side is the swatch to get the right behavior
function replaceJsonOptionsOnPDP() {
  var arrayColorOrder = [];
  var newVariantsObjOrdered = [];

  var swatchColorOptionsItemSelector = $("[data-id='0'] [data-swatch-item]");
  var jsonVariantsSelector = $(".pr_variants_json");
  var jsonOptionSelector = $(".pr_options_json");

  if (jsonVariantsSelector.length > 0 && jsonOptionSelector.length > 0) {
    var jsonVariantsObj = JSON.parse(jsonVariantsSelector.html());
    var jsonOptionsObj = JSON.parse(jsonOptionSelector.html());

    jsonOptionsObj[0].values = [];

    swatchColorOptionsItemSelector.each(function () {
      var color = $(this).attr("title");
      jsonOptionsObj[0].values.push(color);
      var swatchGroupedByColor = jsonVariantsObj.filter(function (item) {
        return item.option1 == color;
      });
      newVariantsObjOrdered.push(...swatchGroupedByColor);
    });

    var newVariantJsonObj = JSON.stringify(newVariantsObjOrdered);
    var newOptionsObj = JSON.stringify(jsonOptionsObj);

    jsonVariantsSelector.html(newVariantJsonObj);
    jsonOptionSelector.html(newOptionsObj);
  }
}

// Hide or Show the Clearance message on PDP
function clearanceDisclaimer() {
  var clearanceSelector = $(
    ".is-t4s-name__color .t4s-swatch__list .t4s-swatch__item"
  );
  var clearanceMessage = $("#clearance-disclaimer");

  // Initial check on page load with a timeout
  setTimeout(function () {
    var initialSelected = clearanceSelector
      .filter(".is--selected")
      .toArray()
      .some(function (swatch) {
        return (
          $(swatch).attr("data-price-type") === "Clearance" &&
          !$(swatch).hasClass("is--soldout")
        );
      });
    clearanceMessage.toggle(initialSelected);
  }, 500);

  // Event listener for swatch clicks
  clearanceSelector.on("click", function () {
    var priceTypeValue = $(this).attr("data-price-type");
    var isClearance =
      priceTypeValue === "Clearance" && !$(this).hasClass("is--soldout");
    clearanceMessage.toggle(isClearance);
  });
}

function clearanceDisclaimerForQuickView(swatchSelected) {
  var clearanceMessage = $("#clearance-disclaimer");

  var priceTypeValue = $(swatchSelected).attr("data-price-type");
  if (priceTypeValue === "Clearance" && !$(this).hasClass("is--soldout")) {
    clearanceMessage.show();
  } else {
    clearanceMessage.hide();
  }
}

// Hide Gift card data elements in checkout
const checkoutDataElements = document.querySelectorAll(
  ".ecom-cart__product-product-option"
);

// Loop through each element
checkoutDataElements.forEach((element) => {
  // Check if the inner text of the element includes '__shopify_send_gift_card_to_recipient:' or '__shopify_offset:'
  if (
    element.innerText.includes("__shopify_send_gift_card_to_recipient:") ||
    element.innerText.includes("__shopify_offset:") ||
    element.innerText.includes("Send on:")
  ) {
    // Hide the element
    element.style.display = "none";
  }
});

// Container where the popUp will be inserted
const targetNode = document.body;

// Observer configuration
const config = { childList: true, subtree: true, attributes: true };

// Callback function for the observer
const callback = function (mutationsList, observer) {
  // Disconnect the observer before making changes to avoid infinite loops
  observer.disconnect();

  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      // Get the PopUp Selector when added to the DOM
      const popup = document.querySelector("#tdf_quickview");
      if (popup) {
        const h3Element = document.querySelector(".tdf_qv_h3");
        if (h3Element) {
          h3Element.innerHTML = "<strong>Select a free gift!!!</strong>";
        }
      }

      const popupQuickShop = document.querySelector(
        ".t4s-modal.t4s-modal--is-active"
      );
      if (popupQuickShop && !popupQuickShop.dataset.processed) {
        popupQuickShop.dataset.processed = true;
        const quickShopView = document.querySelector("#t4s-product-quick-view");
        const quickShop = document.querySelector("#t4s-product-quick-shop");
        if (quickShopView || quickShop) {
          setTimeout(() => {
            renderProductImageOnQuickShopModal();
            // clearanceDisclaimerForQuickView();
          }, 100);
        }
      }
    }
  }

  // Reconnect the observer after changes
  observer.observe(targetNode, config);
};

// Create the MutationObserver instance
const observer = new MutationObserver(callback);

// Initialize the observer
observer.observe(targetNode, config);

/* Code for Catalog Request */
function FixCatalogsAddedToDwawerCart() {
  const addCatalogBtn = $(".ecom-product-single__add-to-cart--submit");
  const current_page = window.location.href;
  if (
    current_page.includes("view-online-catalogs") ||
    current_page.includes("request-medpro-kit")
  ) {
    addCatalogBtn
      .map(function (index, item) {
        let productId = $(item).attr("data-variant-id");
        fetchCart(productId, "load");
      })
      .get();
  }
}

async function fetchCart(productId, event) {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const cart = await response.json();
    cart.items.map(function (item) {
      if (productId == String(item.id)) {
        $(
          `.ecom-product-single__add-to-cart--submit[data-variant-id='${item.id}']`
        ).css("display", "none");
        setTimeout(refreshCart(), 1500);
      }
    });
  } catch (error) {
    console.error("Error fetching the cart:", error);
  }
}

function refreshCart() {
  T4SThemeSP.Drawer.opend(jQuery("#t4s-mini_cart"));
}

function deleteCatalogFromMiniCart() {
  const removeBMiniCartBtn = "a.t4s-mini_cart__remove";
  const decreaseQtyMiniCartBtn =
    "button[data-quantity-selector][data-decrease-qty]";
  const combinedSelector = `${removeBMiniCartBtn}, ${decreaseQtyMiniCartBtn}`;

  const current_page = window.location.href;
  if (
    current_page.includes("view-online-catalogs") ||
    current_page.includes("request-medpro-kit")
  ) {
    jQuery(document).on("click", combinedSelector, function (event) {
      const current_page = window.location.href;

      if (
        current_page.includes("view-online-catalogs") ||
        current_page.includes("request-medpro-kit")
      ) {
        const cartItemClass = $(this)
          .closest("[data-cart-item]")
          .attr("class")
          .split(" ")
          .find((cls) => cls.startsWith("cart_item_"));

        const currentItemValue = cartItemClass
          ? cartItemClass.split("_").at(-1)
          : null;

        if (currentItemValue) {
          $(
            `.ecom-product-single__add-to-cart--submit[data-variant-id='${currentItemValue}']`
          ).css("display", "");
        }
        setTimeout(FixCatalogsAddedToDwawerCart, 2500);
      }
    });
  }
}
/* End catalog Request Code */

//  SEO Description on collections
function toggleDescription(blockId) {
  var seoDescription = document.getElementById("accordian-seo-description");

  // Check if the description is already expanded or collapsed
  if (
    seoDescription.style.maxHeight === "0px" ||
    seoDescription.style.maxHeight === ""
  ) {
    // If collapsed, set max-height to a large value to reveal the content
    seoDescription.style.maxHeight = seoDescription.scrollHeight + "px"; // scrollHeight gives the natural height of the content
  } else {
    // If expanded, collapse the description by setting max-height to 0
    seoDescription.style.maxHeight = "0";
  }
}

//Hide Swatch on Markdown

function HideSwatchOnMarkdownOnRegularParent() {
  const swatchMarkdownSelectorToHide = $(".markdown.t4s-swatch__item");
  const markdownContainer = $(".markdown-price-container");

  if (!markdownContainer.data("click-bound")) {
    markdownContainer.on("click", function () {
      swatchMarkdownSelectorToHide.toggleClass(
        "hide-markdown-on-regular-parent"
      );
      $(this).find(".arrow-icon").toggleClass("open");
    });
    markdownContainer.data("click-bound", true);
  }

  if (markdownContainer.hasClass("regular-parent")) {
    if (swatchMarkdownSelectorToHide.hasClass("is--selected")) {
      swatchMarkdownSelectorToHide.removeClass(
        "hide-markdown-on-regular-parent"
      );
      markdownContainer.find(".arrow-icon").addClass("open");
    } else {
      swatchMarkdownSelectorToHide.addClass("hide-markdown-on-regular-parent");
      markdownContainer.find(".arrow-icon").removeClass("open");
    }
  }
}
